import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { addPageAction } from '@nike/ux-tread-new-relic';
import getRemovePromotionCodeOptions from "../remove-promotion-code/get-options";
var EVENT_NAME = 'Handling Cart Error';

/**
 * Helper function to remove a promotion code from the cart
 * @param {Object} params - Parameters object
 * @param {string} params.promotionCode - The promotion code to remove
 * @param {Object} params.queryClient - React Query client instance
 * @returns {Promise} Result of the remove promotion code mutation
 */
var handleRemovePromotionCode = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var promotionCode, queryClient, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          promotionCode = _ref.promotionCode, queryClient = _ref.queryClient;
          _context.prev = 1;
          _context.next = 2;
          return queryClient.getMutationCache().build(queryClient, _objectSpread(_objectSpread({}, getRemovePromotionCodeOptions({
            queryClient: queryClient
          })), {}, {
            variables: {
              promotionCode: promotionCode
            }
          })).execute();
        case 2:
          return _context.abrupt("return", _context.sent);
        case 3:
          _context.prev = 3;
          _t = _context["catch"](1);
          addPageAction(EVENT_NAME, {
            error: 'Failed to remove promotion code',
            promotionCode: promotionCode,
            errorMessage: _t.message
          });
          return _context.abrupt("return", _t);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function handleRemovePromotionCode(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default handleRemovePromotionCode;